/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { dppEventsFromPurchase } from '@/data/dpp/fromGtm';
import { trackDppEvents } from '@/data/dpp/tracker';
import { clearRepurchaseCouponStorage } from '@/data/Content/AccountCouponsStorage';
import { sendGTMPurchaseEvent } from '@/data/events/handlers/gtm/Purchase';
import { GTMPurchasePayload } from '@/data/types/GTM';

type PurchaseDelegatorProps = {
	gtm?: GTMPurchasePayload;
};

export const purchaseDelegator = async (payload: PurchaseDelegatorProps) => {
	clearRepurchaseCouponStorage();
	const { gtm } = payload;
	if (gtm) {
		trackDppEvents(dppEventsFromPurchase(gtm));
		await sendGTMPurchaseEvent(gtm);
	}
};
